import { Card as CardAntd, Steps as StepsAntd } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .height-85 {
    height: 85vh;
    min-height: 85vh;
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  h3.ant-typography {
    font-size: 20px;
    color: #676A6C;
    margin-top: 40px;
  }

  .resize-textarea-none{
    textarea{
      resize: none;
    }
  }
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 12px 24px;
  }
`;

export const Steps = styled(StepsAntd)`
  padding: 24px 0;

  .ant-steps-item-title,
  .ant-steps-icon {
    font-weight: bold;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    border-bottom: dashed #1890ff;
    border-radius: unset;
    background-color: unset;
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    border: 1px solid rgba(36, 169, 93, 1);
    background-color: rgba(36, 169, 93, 1);
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-icon
    .ant-steps-icon {
    color: #fff !important;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    background-color: #fff;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85) !important;
    margin: 0px 2px;
  }

  .ant-steps .ant-steps-item-finish .ant-steps-icon,
  .ant-steps .ant-steps-item-finish .ant-steps-item-title {
    color: #676a6c !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background: #4190f7;
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #fff;
  }
`;
